import axios from "axios";

export const api = axios.create({
    baseURL:"https://doit-port.herokuapp.com/",
})